<template>
  <div class="xgzl-box" v-if="show" @click="show = false">
  	<div class="xgzl-box-model" @click.stop>
  		<div class="xgzl-box-model-top">
  			<div class="xgzl-box-model-top-title">{{$t('all.xiugaiziliao')}}</div>
			<img src="../../assets/image/wode_jiazu@2x.png" alt="" @click="show = false"/>
  		</div>
		<div class="xgzl-box-model-img">
			<img class="xgzl-box-model-img-img" :src="form.headPortrait" alt="" @click="handleUploadClick"/>
			<!-- 隐藏的文件选择器 -->
			<input
			  type="file"
			  ref="fileInput"
			  style="display: none"
			  accept="image/*"
			  @change="handleFileChange"
			/>
		</div>
		<div class="xgzl-box-model-img-input">
			<input v-model="form.nickName" type="text" :placeholder="$t('all.qingshuru')"/>
		</div>
		<div class="xgzl-box-model-btn">
			<div class="xgzl-box-model-bottom" @click="updUserInfo">{{$t('all.tijiao')}}</div>
		</div>
  	</div>
  </div>
</template>

<script>
import { getPresentUserInfo,updUserInfo } from "@/api/user";
import { client as createCosClient } from '../../common/js/txycos';
export default {
  data() {
    return {
	  show:false,
	  form:{
		headPortrait:'',
		nickName:''
	  },
	  cosClient: null,
    };
  },
  mounted() {
	this.cosClient = createCosClient();
  },
  methods: {
	//用户详情
	async getPresentUserInfo(data){
		const res = await getPresentUserInfo()
		this.form = JSON.parse(JSON.stringify(res.data))
		if(data == 1){
			this.$store.commit('changeUserInfo', res.data);
		}
	},
	//修改资料
	async updUserInfo(){
		const res = await updUserInfo(this.form)
		this.$message({ message: res.msg,type: 'success'});
		this.getPresentUserInfo(1)
		this.show = false
	},
	showModel(){
		this.show = true
		this.getPresentUserInfo()
	},
    // 触发文件选择（原有逻辑不变，无需修改）
    handleUploadClick() {
      this.$refs.fileInput.click();
    },
    
    // 处理文件选择（原有逻辑优化，适配 COS 上传）
    handleFileChange(event) {
      const fileList = event.target.files;
      if (!fileList || fileList.length === 0) return;
      // 仅上传第一张图片（符合页面单张背景图的需求）
      this.uploadToCOS(fileList[0]);
      // 重置文件输入框，避免重复选择同一文件不触发 change 事件
      event.target.value = '';
    },
    
    // 核心改造：腾讯云 COS 单张图片上传（替换原有阿里云 OSS 上传）
    async uploadToCOS(file) {
      // 校验 1：文件是否合法
      if (!file || !file.type.startsWith('image/')) {
    	this.$message.error('请选择有效的图片文件');
    	return;
      }
      try {
    	// 1. 构造唯一文件名（按直播背景图分类存储，方便管理）
    	const fileExt = file.name.split('.').pop() || 'png';
    	const fileName = `webStorage/web_/${Date.now()}_${Math.random().toString(36).substr(2, 10)}.${fileExt}`;
    
    	// 2. 调用 COS putObject 方法上传（回调转 Promise，适配 async/await）
    	const uploadResult = await new Promise((resolve, reject) => {
    	  this.cosClient.putObject({
    		Bucket: this.cosClient.options.bucket,
    		Region: this.cosClient.options.region,
    		Key: fileName,
    		Body: file,
    		ContentType: file.type || 'image/jpeg', // 兜底图片 MIME 类型
    		onProgress: (progressData) => {
    		  // 可选：上传进度回调，如需显示进度可在此扩展
    		  console.log('图片上传进度：', (progressData.percent * 100).toFixed(2) + '%');
    		}
    	  }, (err, result) => {
    		if (err) reject(err);
    		else resolve(result);
    	  });
    	});
    
    	// 3. 拼接 COS 图片访问 URL，赋值给表单背景图
    	const imageUrl = `https://${this.cosClient.options.bucket}.cos.${this.cosClient.options.region}.myqcloud.com/${fileName}`;
    	// 或使用 uploadResult.Location 直接获取完整 URL：
    	this.form.headPortrait = imageUrl;
    
    	// this.$message.success('直播背景图上传成功');
    	console.log('背景图上传成功，地址：', this.form.headPortrait);
    
      } catch (error) {
    	console.error('直播背景图上传失败：', error);
    	this.$message.error('背景图上传失败，请稍后重试');
      }
    },
  }
};
</script>
<style scoped lang="scss">
	@import "./xiugaiziliao.css";
</style>


// WEBPACK FOOTER //
// xiugaiziliao.vue?8c705772